import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoffeeEspressoMachine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "coffee-espresso-machine" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: .75,
			y1: 23.25,
			x2: 23.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,2.25a1.5,1.5,0,0,0-1.5-1.5H4.5A1.5,1.5,0,0,0,3,2.25v6a1.5,1.5,0,0,0,1.5,1.5H12a1.5,1.5,0,0,1,1.5,1.5v12h9.75v-21Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.75,23.25h4.5V12.75h-3a1.5,1.5,0,0,0-1.5,1.5Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.75,
			y1: 9.75,
			x2: 6.75,
			y2: 12.75
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 7.5,
			cy: 5.25,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 23.25,
			y1: 5.25,
			x2: 18.75,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 23.25,
			y1: 8.25,
			x2: 18.75,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M3.094,18c0,2.071,0,5.25,3.75,5.25,3,0,3.216-2.695,3.632-4.313A.75.75,0,0,0,9.749,18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M3.094,18h0a2.25,2.25,0,0,0-2.25,2.25h0"
		})
	]
});
export default SvgCoffeeEspressoMachine;
